import React, { useContext, useEffect } from "react";
import { Modal } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import ModalHeaderLayout from "../../layouts/ModalHeaderLayout";
import UserContext from "../../Context/UserContext";

const AddOrderModal = ({
  isModalOpenAddOrder,
  setIsModalOpenAddOrder,
  socket,
  allData,
}) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({

    target: "",
    order: "",
    tip: "",
    color: "",
    sequence: ""
  });
  const { user } = useContext(UserContext)


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  let allSPVNo = allData
    .filter(item => item.fields.is_started_asma === false)
    .map(item => item.fields.sequence);


  const handleSubmit = (e) => {
    socket.send(
      JSON.stringify({
        event_type: "NewOrderAddEvent",
        production: formData.target,
        siparis: formData.order,
        sequence: formData.sequence,
        tip: formData.tip,
        renk: formData.color,
        user: user.accountDetail.name,

      })
    );
  };

  return (
    <Modal
      title=<ModalHeaderLayout title={t("addOrder.addOrder")} />
      open={isModalOpenAddOrder}

      footer={null}
      onOk={() => setIsModalOpenAddOrder(false)}
      onCancel={() => {
        setFormData({
          target: "",
          order: "",
          tip: "",
          color: "",
          sequence: ""
        });
        setIsModalOpenAddOrder(false);
      }}
      centered
      className="min-w-max mb-40"
    >
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col text-3xl gap-5 p-5 w-[700px]">
          <div className="flex flex-row w-full gap-2 items-center">
            <div className="w-56 flex justify-between">
              <label>{t("addOrder.target")}</label>
              <span>:</span>
            </div>
            <input

              name="target"
              onWheel={(e) => e.target.blur()}
              type="number"
              required
              min="1"
              onChange={handleChange}
              value={formData.target}
              placeholder={t("addOrder.targetPlaceholder")}
              className="flex w-full text-center text-3xl border-[2px] border-black rounded-md"

            />
          </div>

          <div className="flex flex-row w-full gap-2 items-center">
            <div className="w-56 flex justify-between">
              <label>{t("addOrder.order")}</label>
              <span>:</span>
            </div>
            <select

              name="order"
              onChange={handleChange}
              value={formData.order}
              required
              className="flex w-full text-center text-3xl border-[2px] border-black rounded-md"
            >
              <option disabled selected value="">
                {t("addOrder.select")}
              </option>
              <option value="Çift Gövde Ön">{t("addOrder.doubleFrontBody")}</option>
              <option value="Gövde">{t("addOrder.body")}</option>
            </select>

          </div>
          <div className="flex flex-row w-full gap-2 items-center">
            <div className="w-56 flex justify-between">
              <label>{t("addOrder.type")}</label>
              <span>:</span>
            </div>


            <select
              name="tip"
              onChange={handleChange}
              value={formData.tip}
              required
              className="flex w-full text-center text-3xl border-[2px] border-black rounded-md"
            >
              <option disabled selected value="">
                {t("addOrder.select")}
              </option>
              {(() => {

                switch (formData.order) {
                  case "Gövde": return <>
                    <option value="Single F14">{t("addOrder.singleF14Body")}</option>
                    <option value="U">{t("addOrder.uBody")}</option>
                  </>

                  case "Çift Gövde Ön": return <>
                    <option value="F14">F14</option>
                    <option value="F23">F23</option>
                  </>
                  default: return null
                }
              })()}

            </select>
          </div>
          <div className="flex flex-row w-full gap-2 items-center">
            <div className="w-56 flex justify-between">
              <label>{t("addOrder.color")}</label>
              <span>:</span>
            </div>


            <select
              name="color"
              onChange={handleChange}
              value={formData.color}
              required
              className="flex w-full text-center text-3xl border-[2px] border-black rounded-md"
            >
              <option disabled selected value="">
                {t("addOrder.select")}
              </option>
              <option value="Silver">{t("addOrder.silver")}</option>
              <option value="Beyaz">{t("addOrder.white")}</option>
              <option value="Cast Iron">{t("addOrder.castIron")}</option>


            </select>
          </div>
          <div className="flex flex-row w-full gap-2 items-center">
            <div className="w-56 flex justify-between">
              <label>{t("addOrder.spvNo")}</label>
              <span>:</span>
            </div>
            <select

              name="sequence"
              onChange={handleChange}
              value={formData.sequence}
              required
              className="flex w-full text-center text-3xl border-[2px] border-black rounded-md"
            >
              <option className="text-lg" disabled selected value="">
                {t("addOrder.select")}
              </option>
              {

                allSPVNo?.map((item, index) => {
                  return <option key={index} className="text-lg" value={item}>{item}</option>
                })
              }
            </select>
          </div>
        </div>

        <button
          className="h-[80px] bg-mainYellow w-full text-[40px] rounded-b-xl hover:bg-secondYellow"
          type="submit"
        >
          {t("addOrder.submit")}
        </button>

      </form>
    </Modal>
  );
};

export default AddOrderModal;
